// extracted by mini-css-extract-plugin
export default {"navRow":"Navbar_navRow__TSTvO","icon":"Navbar_icon__zclbV","title":"Navbar_title__7PDyG","social":"Navbar_social__KBKG6"};